 export const defaultRightWindowWidget = "";

// export const developmentMapConfig = {
//   portalURL:"https://ocpw.maps.arcgis.com",
//   mapPublic:true,
//   widgets: { 
//     addGraphicFromSource:{show:false,callback:""},
//     basemapToggle:{show:true,mapId:"8cab93c23fff45259108394279c20bc2"}, basemapGallery: {show:true,query:{
//     title: "Custom Basemap Gallery",
//     owner: "OCPublicWorks"
//   }}, bookmarks:true, bugReport:false, coordinateConversion:true, draw:true, editor:false,elevProfile:{show:true,name:'Elevation Profile',alias:'Elevation Profile',widgetLocation:'horizontal'},
//    export:true, measure:true,
//    opMaintReport:{show:false}, streetView:true,swipe:true,
//     print:{show:true,serviceUrl:'https://www.ocgis.com/arcpub/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task'},
//      project: false,timeChart:{show:true,name:'Time Chart', alias:'Time Chart',minSelectRequired:1,widgetLocation:'horizontal'} },
// };

// export const surveyMapConfig = {
//   id:2,
//   portalURL:"https://ocpw.maps.arcgis.com",
//   mapId:"3f5dd6cb130b4bd5b6004f18f20a9679",
//   mapPublic:true,
//   widgets: {
//     addGraphicFromSource:{show:false,callback:""},
//     basemapToggle:{show:true,mapId:"4cd1ca98be04433a976b71bc14d61769"}, basemapGallery: {show:true,query:{
//     title: "Custom Basemap Gallery",
//     owner: "OCPublicWorks"
//   }}, bookmarks:true, bugReport:false, coordinateConversion:true, draw:true, editor:false,elevProfile:{show:true,name:'Elevation Profile',alias:'Elevation Profile',widgetLocation:'horizontal'},
//    export:true, measure:true,
//    opMaintReport:{show:false}, streetView:true,swipe:true,
//     print:{show:true,serviceUrl:'https://www.ocgis.com/arcpub/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task'},
//      project: false,surveyRef:{show:false,name:'Survey Reference',alias:'Survey Reference',widgetLocation:'horizontal',minSelectRequired:1}, timeChart:{show:true,name:'Time Chart', alias:'Time Chart',minSelectRequired:1,widgetLocation:'horizontal'} },
// };

// export const cornerRecordMapConfig = {
//   id:3,
//   portalURL:"https://ocpw.maps.arcgis.com",
//   mapPublic:false,
//   toolbars:{
//     featureWidget:true
//   },
//   widgets: { 
//     addGraphicFromSource:{show:false,callback:""},
//     basemapToggle:{show:true,mapId:"4cd1ca98be04433a976b71bc14d61769"}, basemapGallery: {show:true,query:{
//     title: "Custom Basemap Gallery",
//     owner: "OCPublicWorks"
//   }}, bookmarks:true, bugReport:false, coordinateConversion:true, cornerRecordEdit:true,draw:true, editor:false,elevProfile:{show:true,name:'Elevation Profile',alias:'Elevation Profile',widgetLocation:'horizontal'},
//    export:true, measure:true,
//    opMaintReport:{show:false}, streetView:true,swipe:true,
//    parcelEdit:false,
//     print:{show:true,serviceUrl:'https://www.ocgis.com/arcpub/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task'},
//      project: false,surveyRef:{show:true,name:'Survey Reference',alias:'Survey Reference',widgetLocation:'horizontal',minSelectRequired:1},timeChart:{show:true,name:'Time Chart', alias:'Time Chart',minSelectRequired:1,widgetLocation:'horizontal'}},
// };

// export const demoSurveyMapConfig = {
//   id:1,
//   portalURL:"https://ocpw.maps.arcgis.com",
//   mapId:"3f5dd6cb130b4bd5b6004f18f20a9679",
//   mapPublic:true,
//   toolbars:{
//     featureWidget:true
//   },
//   widgets: { 
//     addGraphicFromSource:{show:false,callback:""},
//     basemapToggle:{show:true,mapId:"4cd1ca98be04433a976b71bc14d61769"}, basemapGallery: {show:true,query:{
//     title: "Custom Basemap Gallery",
//     owner: "OCPublicWorks"
//   }}, bookmarks:true, bugReport:false, coordinateConversion:true, cornerRecordEdit:false,draw:true, editor:false,elevProfile:{show:true,name:'Elevation Profile',alias:'Elevation Profile',widgetLocation:'horizontal'},
//    export:true, measure:true,
//    opMaintReport:{show:false}, streetView:true,swipe:true,
//    parcelEdit:false,
//     print:{show:true,serviceUrl:'https://www.ocgis.com/arcpub/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task'},
//      project: false,surveyRef:{show:true,name:'Survey Reference',alias:'Survey Reference',widgetLocation:'horizontal',minSelectRequired:1},timeChart:{show:true,name:'Time Chart', alias:'Time Chart',minSelectRequired:1,widgetLocation:'horizontal'}},
// };

// export const assessorMapConfig = {
//   id:4,
//   portalURL:"https://ocpw.maps.arcgis.com",
//   mapId:"3f5dd6cb130b4bd5b6004f18f20a9679",
//   mapPublic:true,
//   toolbars:{
//     featureWidget:false
//   },
//   widgets: {
//     addGraphicFromSource:{show:true,callback:""},
//     basemapToggle:{show:true,mapId:"4cd1ca98be04433a976b71bc14d61769"}, basemapGallery: {show:true,query:{
//     title: "Custom Basemap Gallery",
//     owner: "OCPublicWorks"
//   }}, bookmarks:true, bugReport:false, coordinateConversion:true, draw:true, editor:false,elevProfile:{show:true,name:'Elevation Profile',alias:'Elevation Profile',widgetLocation:'horizontal'},
//    export:true, measure:true,
//    opMaintReport:{show:false}, streetView:true,swipe:true,
//     print:{show:true,serviceUrl:'https://www.ocgis.com/arcpub/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task'},
//      project: false,surveyRef:{show:false,name:'Survey Reference',alias:'Survey Reference',widgetLocation:'horizontal',minSelectRequired:1},timeChart:{show:false,name:'Time Chart', alias:'Time Chart',minSelectRequired:1,widgetLocation:'horizontal'} },
// };

// export const surveyFieldServicesMapConfig = {
//   portalURL:"https://ocpw.maps.arcgis.com",
//   mapPublic:true,
//   widgets: {
//     addGraphicFromSource:{show:false,callback:""},
//     basemapToggle:{show:true,mapId:"4cd1ca98be04433a976b71bc14d61769"}, basemapGallery: {show:true,query:{
//     title: "Custom Basemap Gallery",
//     owner: "OCPublicWorks"
//   }}, bookmarks:true, bugReport:false, coordinateConversion:true, draw:true, editor:false,elevProfile:{show:true,name:'Elevation Profile',alias:'Elevation Profile',widgetLocation:'horizontal'},
//    export:true, measure:true,
//    opMaintReport:{show:false}, streetView:true,swipe:true,
//     print:{show:true,serviceUrl:'https://www.ocgis.com/arcpub/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task'},
//      project: false,surveyRef:{show:false,name:'Survey Reference',alias:'Survey Reference',widgetLocation:'horizontal',minSelectRequired:1},timeChart:{show:true,name:'Time Chart', alias:'Time Chart',minSelectRequired:1,widgetLocation:'horizontal'} },
// };

// export const omMapConfig = {
//   id:5,
//   portalURL:"https://ocpw.maps.arcgis.com",
//   mapPublic:false,
//   widgets: {
//     addGraphicFromSource:{show:false,callback:""},
//     basemapToggle:{show:true,mapId:"4cd1ca98be04433a976b71bc14d61769"}, basemapGallery:{show:true,query:{
//     title: "Custom Basemap Gallery",
//     owner: "OCPublicWorks"
//   }}, bookmarks:true, bugReport:false, coordinateConversion:true, draw:true, editor:true,elevProfile:{show:true,name:'Elevation Profile',alias:'Elevation Profile',widgetLocation:'horizontal'}, export:true, measure:true,
//   opMaintReport:{show:true}, streetView:true, swipe:true, print:{show:true,serviceUrl:'https://www.ocgis.com/arcpub/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task'}, project: false,
//   surveyRef:{show:false,name:'Survey Reference',alias:'Survey Reference',widgetLocation:'horizontal',minSelectRequired:1},timeChart:{show:true,name:'Time Chart', alias:'Time Chart',minSelectRequired:1,widgetLocation:'horizontal'} },
// };

// export const surveyLiteConfig = {
//   portalURL:"https://gis.ocgov.com/portal",
//   mapPublic:false,
//   widgets: {
//     addGraphicFromSource:{show:false,callback:""},
//     basemapToggle:{show:false,mapId:"4cd1ca98be04433a976b71bc14d61769"}, basemapGallery:{show:false,query:{
//     title: "Custom Basemap Gallery",
//     owner: "OCPublicWorks"
//   }}, bookmarks:true, bugReport:true, coordinateConversion:false, draw:true, editor:true,elevProfile:{show:true,name:'Elevation Profile',alias:'Elevation Profile',widgetLocation:'horizontal'}, export:true, measure:true,
//   opMaintReport:{show:false}, streetView:true, swipe:true, print:{show:true,serviceUrl:'https://gis.ocgov.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task'}, project: false,
//   surveyRef:{show:false,name:'Survey Reference',alias:'Survey Reference',widgetLocation:'horizontal',minSelectRequired:1},timeChart:{show:true,name:'Time Chart', alias:'Time Chart',minSelectRequired:1,widgetLocation:'horizontal'} },
// };
